import React, { useCallback, useState } from 'react'
import get from 'lodash/get'
import { Box, Flex } from '@rebass/grid'
import styled from 'styled-components'
import { size } from 'styled-theme'
import { useNavigate } from 'react-router-dom'
import Text from '../../atoms/Text'
import Link from '../../atoms/Link'
import Button from '../../atoms/Button'
import Viewport from '../../atoms/Viewport'
import ContentBox from '../../atoms/ContentBox'
import AdSenseGroupView from '../../molecules/AdSenseGroupView'
import RegisterForm from '../../organisms/RegisterForm'
import { getErrorMessage } from '../../../utlils/form'
import { useAuth } from '../../../contexts/auth'
import { useLoading } from '../../../contexts/loading'
import { completeGoogleRegister } from '../../../api/auth'
import { getStoredAuth } from '../../../api'

const StyledViewport = styled(Viewport)`
 padding: 8rem 2rem 3rem;
 align-items: flex-start;
  @media only screen and (max-width: ${size('mobile')}) {
    padding: 4rem 0 0;
  }
`

const CompleteProfilePage = () => {
  const [registeredUser, setRegisteredUser] = useState(null)
  const { auth, setAuth } = useAuth()
  const { setLoading } = useLoading()
  const navigate = useNavigate()

  const goToHome = useCallback(() => {
    const newAuth = {
      ...getStoredAuth(),
      user: registeredUser,
    }
    setAuth(newAuth)
    return navigate('/profile', { replace: true })
  }, [registeredUser, navigate, setAuth])

  const onSubmit = useCallback((values, { setFieldError }) => {
    const updateBody = {
      username: values.username,
      sex: values.sex,
      phone_number: values.phone_number,
      description: values.description,
    }
    setLoading(true)
    return completeGoogleRegister(auth.user?.username, updateBody)
      .then(({ data: updatedUser }) => {
        setRegisteredUser(updatedUser)
      })
      .catch(((err) => {
        setFieldError('form', getErrorMessage(err))
      }))
      .finally(() => {
        setLoading(false)
      })
  }, [auth.user, setLoading])

  return (
    <StyledViewport>
      <ContentBox>
        {!registeredUser ? (
          <>
            <Flex justifyContent="center" mb="2rem">
              <Text palette="primary" bold variant="h2">請填寫資料以繼續</Text>
            </Flex>
            <RegisterForm
              user={get(auth, 'user')}
              onRegister={onSubmit}
            />
          </>
        ) : (
          <Flex flexDirection="column" alignItems="center">
            <Text palette="primary" bold variant="h1" align="center">
              多謝你嘅註冊，
              <span style={{ wordBreak: 'keep-all', textWrap: 'nowrap' }}>{get(registeredUser, 'username')}！</span>
            </Text>
            <Box mt="1rem">
              <Text palette="primary" bold variant="h2" align="center">
                Crush A.I. 愛情顧問已經等緊你！
              </Text>
            </Box>
            <Box mt="2.8rem">
              <Text variant="h3" align="center">
                仲唔快啲follow 我哋IG&nbsp;
                <Link href="https://www.instagram.com/crushk.co">@crushk.co</Link>
                &nbsp;緊貼我哋最新消息！
              </Text>
            </Box>
            <Box mt="1rem">
              <Text variant="h3" align="center">
                你亦可以上&nbsp;
                <Link href="https://www.crushk.co">crushk.co</Link>
                &nbsp;了解更多關於<b>Crush</b>嘅故事。我哋期待你喺依度搵到真愛。
              </Text>
            </Box>
            <Box mt="1rem">
              <Text variant="body1" align="center">
                合作 / 查詢: <Link href="mailto:contact@crushk.co">contact@crushk.co</Link>
              </Text>
            </Box>
            <Box mt="2rem">
              <Button onClick={goToHome}>開始使用</Button>
            </Box>
          </Flex>
        )}
      </ContentBox>
      <AdSenseGroupView />
    </StyledViewport>
  )
}

export default CompleteProfilePage
